// extracted by mini-css-extract-plugin
export default {"canvasContainer":"KonvaCanvas__canvasContainer___tvIkC"};